import { VALIDATION_ERRORS } from "../../errors";
import { Yup } from "../../yup";

export const getStringSelectionRequiredSchema = (string: string) => Yup.string().required(VALIDATION_ERRORS.selectionRequired(string));
